export default __webpack_public_path__ + "static/media/certilytics.f3abeb94.png";